import React from "react";

import { Menu, MenuItem } from "@material-ui/core";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";

const SelectMenuItems = ({
	fieldName,
	anchorElement,
	listItems,
	handleMenuClose,
	handleSelecMenuItemClick
}: any): any => {
	return (
		<div>
			<Menu
				id="simple-menu"
				anchorEl={anchorElement}
				keepMounted
				open={Boolean(anchorElement)}
				onClose={() => handleMenuClose(null)}
			>
				{listItems.map((item: string, index: number) => (
					<MenuItem
						key={index}
						value={initCapitalize(item)}
						onClick={(event): React.MouseEvent<HTMLLIElement, MouseEvent> =>
							handleSelecMenuItemClick(event, "role")
						}
					>
						{initCapitalize(item)}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};

export default SelectMenuItems;
